export default [
  {
    name: "Dashboard",
    icon: "fas fa-tachometer-alt",
    path: "/overview",
    allowedRoles: ["ADMIN", "SITE_OWNER"],
    show: (() => {

      var p = localStorage.getItem("permissions");
      if (p) {
        let canshow = p.includes("dashboard.get");
        if (canshow) {
          return true;
        } else {
          return false;
        }
      }
    })()
  },
  {
    name: "Site Management",
    icon: "fas fa-cogs",
    path: "/sites",
    allowedRoles: ["ADMIN", "SITE_OWNER"],
    show: (() => {
      var p = localStorage.getItem("permissions");
      if (p) {
        let canshow = p.includes("site.get");

        if (canshow) {
          return true;
        } else {
          return false;
        }
      }
    })()
  },
  {
    name: "Purchase",
    icon: "fas fa-cash-register",
    path: "/purchase",
    allowedRoles: ["ADMIN"],
    show: (() => {
      var p = localStorage.getItem("permissions");
      if (p) {
        let canshow = p.includes("booking.post");

        if (canshow) {
          return true;
        } else {
          return false;
        }
      }
    })()
  },
  {
    name: "Bookings",
    icon: "fas fa-calendar-check",
    path: "/bookings",
    allowedRoles: ["ADMIN", "SITE_OWNER"],
    show: (() => {
      var p = localStorage.getItem("permissions");
      if (p) {
        let canshow = p.includes("booking.get");

        if (canshow) {
          return true;
        } else {
          return false;
        }
      }
    })()
  },
  {
    name: "User Management",
    icon: "fas fa-users-cog",
    path: "/user",
    children: [
      {
        name: "Users",
        path: "/users",
        show: (() => {
          var p = localStorage.getItem("permissions");

          if (p) {
            let canshow = p.includes("user.get");

            if (canshow) {
              return true;
            } else {
              return false;
            }
          }
        })()
      },
      {
        name: "Roles",
        path: "/roles",
        show: (() => {
          var p = localStorage.getItem("permissions");

          if (p) {
            let canshow = p.includes("role.get");
            if (canshow) {
              return true;
            } else {
              return true;
            }
          }
        })()
      },
      {
        name: "Permissions",
        path: "/permissions",
        show: (() => {
          var p = localStorage.getItem("permissions");

          if (p) {
            let canshow = p.includes("permission.get");
            if (canshow) {
              return true;
            } else {
              return false;
            }
          }
        })()
      }
    ],
    show: (() => {
      var p = localStorage.getItem("permissions");

      if (p) {
        let canshow = p.includes("user.post");
        if (canshow) {
          return true;
        } else {
          return false;
        }
      }
    })()
  },
  {
    name: "Logout",
    icon: "fas fa-sign-out-alt",
    path: "/logout",
    allowedRoles: ["ADMIN", "SITE_OWNER"],
    show: true
  }

  // {
  //   name: 'Pages',
  //   icon: 'nc-icon nc-book-bookmark',
  //   children: [
  //     {
  //       name: 'Timeline',
  //       path: '/pages/timeline'
  //     },
  //     {
  //       name: 'User Profile',
  //       path: '/pages/user'
  //     },
  //     {
  //       name: 'Login',
  //       path: '/login'
  //     },
  //     {
  //       name: 'Register',
  //       path: '/register'
  //     },
  //     {
  //       name: 'Lock',
  //       path: '/lock'
  //     }
  //   ]
  // },
  // {
  //   name: 'Components',
  //   icon: 'nc-icon nc-layout-11',
  //   children: [{
  //     name: 'Buttons',
  //     path: '/components/buttons'
  //   },
  //   {
  //     name: 'Grid System',
  //     path: '/components/grid-system'
  //   },
  //   {
  //     name: 'Panels',
  //     path: '/components/panels'
  //   },
  //   {
  //     name: 'Sweet Alert',
  //     path: '/components/sweet-alert'
  //   },
  //   {
  //     name: 'Notifications',
  //     path: '/components/notifications'
  //   },
  //   {
  //     name: 'Icons',
  //     path: '/components/icons'
  //   },
  //   {
  //     name: 'Typography',
  //     path: '/components/typography'
  //   }]
  // },
  // {
  //   name: 'Forms',
  //   icon: 'nc-icon nc-ruler-pencil',
  //   children: [{
  //     name: 'Regular Forms',
  //     path: '/forms/regular'
  //   },
  //   {
  //     name: 'Extended Forms',
  //     path: '/forms/extended'
  //   },
  //   {
  //     name: 'Validation Forms',
  //     path: '/forms/validation'
  //   },
  //   {
  //     name: 'Wizard',
  //     path: '/forms/wizard'
  //   }
  //   ]
  // },
  // {
  //   name: 'Table List',
  //   icon: 'nc-icon nc-single-copy-04',
  //   collapsed: true,
  //   children: [{
  //     name: 'Regular Tables',
  //     path: '/table-list/regular'
  //   },
  //   {
  //     name: 'Extended Tables',
  //     path: '/table-list/extended'
  //   },
  //   {
  //     name: 'Paginated Tables',
  //     path: '/table-list/paginated'
  //   }
  //   ]
  // },
  // {
  //   name: 'Maps',
  //   icon: 'nc-icon nc-pin-3',
  //   children: [{
  //     name: 'Google Maps',
  //     path: '/maps/google'
  //   },
  //   {
  //     name: 'Full Screen Maps',
  //     path: '/maps/full-screen'
  //   },
  //   {
  //     name: 'Vector Maps',
  //     path: '/maps/vector-map'
  //   }
  //   ]
  // },
  // {
  //   name: 'Widgets',
  //   icon: 'nc-icon nc-box',
  //   path: '/admin/widgets'
  // },
  // {
  //   name: 'Charts',
  //   icon: 'nc-icon nc-chart-bar-32',
  //   path: '/charts'
  // },
  // {
  //   name: 'Calendar',
  //   icon: 'nc-icon nc-calendar-60',
  //   path: '/calendar'
  // },
];
